import { resolveUiLocale } from './resolveUiLocale';

/**
 * Zendesk Help Center base — keep in sync with {@see App\Support\HelpCenterRedirectUrl}.
 */
const ZENDESK_HC_BASE = 'https://support.evignettehungary.com/hc';

/** ISO 639-1 base code => Zendesk HC path segment — keep in sync with PHP. */
const ZENDESK_LOCALE_BY_LANG = {
    en: 'en-gb',
    bg: 'bg',
    cs: 'cs',
    da: 'da',
    de: 'de',
    es: 'es',
    fr: 'fr',
    hr: 'hr',
    hu: 'hu',
    it: 'it',
    nl: 'nl',
    pl: 'pl',
    ro: 'ro',
    ru: 'ru',
    sk: 'sk',
    sl: 'sl',
    sv: 'sv',
    tr: 'tr',
    uk: 'uk',
};

function zendeskLocaleFromLang(langOrCode) {
    const tag = resolveUiLocale(langOrCode);
    const base = (tag.split('-')[0] || 'en').toLowerCase();
    return ZENDESK_LOCALE_BY_LANG[base] ?? ZENDESK_LOCALE_BY_LANG.en;
}

/**
 * @param {string | { code?: string, help_center_url?: string, help_center_locale?: string }} langOrCode
 * @returns {string} Absolute Zendesk Help Center URL for that language
 */
export function resolveHelpCenterUrl(langOrCode) {
    const lang = typeof langOrCode === 'object' && langOrCode != null ? langOrCode : null;

    const directUrl = lang?.help_center_url ?? lang?.help_center_link;
    if (directUrl != null && String(directUrl).trim() !== '') {
        return String(directUrl).trim();
    }

    const segment =
        lang?.help_center_locale
        ?? lang?.zendesk_locale
        ?? zendeskLocaleFromLang(langOrCode);

    return `${ZENDESK_HC_BASE}/${encodeURIComponent(segment)}`;
}

/**
 * CMS menu paths that should open Zendesk Help Center (header/footer/nav).
 * @param {string | null | undefined} path
 */
export function isHelpCenterMenuPath(path) {
    if (path == null || String(path).trim() === '') {
        return false;
    }
    const normalized = String(path).toLowerCase().replace(/_/g, '-');
    return normalized.includes('help-center') || normalized.includes('helpcenter');
}

/**
 * Resolve a CMS menu item href; Help Center items use {@link resolveHelpCenterUrl}.
 * @param {string | null | undefined} path
 * @param {string | { code?: string }} langOrCode
 */
export function resolveMenuPath(path, langOrCode) {
    if (isHelpCenterMenuPath(path)) {
        return resolveHelpCenterUrl(langOrCode);
    }
    return path != null && String(path).trim() !== '' ? String(path) : '#';
}
